<template>
 <div class="ui centered grid">
    <div class="four wide column"></div>
    <div class="eight wide column">
        Institute of Art History of the Czech Academy of Sciences<br>
        Studia Rudolphina: Research Center for Visual Arts and Culture in the Age of Rudolf II<br>
        
        
        Husova 4<br>
        110 00 Prague 1<br>
        Czech Republic<br><br>
        
        <h4>Project lead</h4>
        PhDr. Štěpán Vácha, Ph.D.<br>
        <img class="ui small image" src="/static/vacha.png" style="margin-top:2px;">
       
        
        <h4>Administrator</h4>
        Mgr. et Mgr. Markéta Ježková, Ph.D.<br>
        <img class="ui small image" src="/static/jezkova.png" style="margin-top:2px;">
       
    </div>
    <div class="four wide column"></div>
</div>


</template>

<script>
   // import TheCarousel from '../components/TheCarousel.vue'
    export default {
        name: 'contact',
        data() {
            return {
            }
        },
       
        components: {
          //  TheCarousel
        },
    }
</script>

<style scoped>
    P{
         text-align: justify;
    }
</style>



// WEBPACK FOOTER //
// src/router/contact.vue